import { Redirection } from "../../features/redirection"

const RedirectPage = () => {
  return <Redirection />
}

export default RedirectPage
